const cache = require("memory-cache");

import { get } from "util/apiRequest";

import getLogger from "../../logger/index";
import clientConfig from "lib/config";
const { config } = require("../../api/config");
const { LISTING_BASE_URL, FRONTDOOR_SERVER } = config.endpoints;

export const GEOLINKS_REQUEST = "GEOLINKS_REQUEST";
export const GEOLINKS_SUCCESS = "GEOLINKS_SUCCESS";
export const GEOLINKS_FAILURE = "GEOLINKS_FAILURE";
export const GEOLINKS_RESET = "GEOLINKS_RESET";
export const RESET = "Resetting";
export const REQUESTING = "Requesting";
export const SUCCESS = "Success";
export const ERROR = "Error";
const log = getLogger("GEOLINKS_REQUEST");

export function GeoLinksRequest() {
  return {
    type: GEOLINKS_REQUEST,
    status: REQUESTING,
  };
}
export function GeoLinksSuccess(geoLinksData) {
  return {
    type: GEOLINKS_SUCCESS,
    status: SUCCESS,
    geoLinksData: geoLinksData,
  };
}
export function GeoLinksFailure(error) {
  return {
    type: GEOLINKS_FAILURE,
    status: ERROR,
    error,
  };
}

export function GeoLinksReset() {
  return {
    type: GEOLINKS_RESET,
    status: RESET,
    geoLinksData: {},
  };
}

/**
 * @desc Formats a property array into 50 random properties for use in ExplorePDP component
 * @param  {Array} propertiesArray [List of property URLS]
 * @return {Array} [Two arrays of 25 random properties]
 */
export const formatGeoLinks = (propertiesArray, url) => {
  const temporaryItems = [
    {
      geoLinks: [
        {
          text: "",
          href: "",
        },
      ],
    },
    {
      geoLinks: [
        {
          text: "",
          href: "",
        },
      ],
    },
    {
      geoLinks: [
        {
          text: "",
          href: "",
        },
      ],
    },
    {
      geoLinks: [
        {
          text: "",
          href: "",
        },
      ],
    },
  ];

  const originalLength = propertiesArray.length;
  let filteredItems = [];

  if (propertiesArray.length) {
    filteredItems = propertiesArray.filter((link) => {
      if (!link.title || !link.url) {
        return false;
      }
      return true;
    });
  }
  if (originalLength > filteredItems.length) {
    log.error("Error - title or url is missing for one or more links", url);
  }

  (filteredItems || []).forEach((link, index) => {
    temporaryItems[index % 4].geoLinks.push({
      text: link.title.trim(),
      href: `${LISTING_BASE_URL}${link.url.trim()}`,
    });
  });

  return temporaryItems;
};

export function geoLinks(isGoogleBot, city, state_code, postalCode, isServerReq) {
  return async (dispatch) => {
    let url;
    const baseURL = isServerReq ? FRONTDOOR_SERVER : clientConfig.FRONTDOOR_CLIENT;
    if (postalCode != null && postalCode != "") {
      url = `${baseURL}/seo-zoho/api/v1/uncrawled-pdps-hestia?client_id=FAR2.0&location=${postalCode}`;
    } else if (city != null && city != "" && state_code != null && state_code != "") {
      url = `${baseURL}/seo-zoho/api/v1/uncrawled-pdps-hestia?client_id=FAR2.0&location=${city}, ${state_code}`;
    }
    try {
      dispatch(GeoLinksRequest());
      // let resultJson = cache.get(url);
      // if (!resultJson) {
      const resultJson = await get(url, 6000);
      // cache.put(url, resultJson, 3600000); //time is in milliseconds 1 hour.
      // }
      // if (resultJson.status !== 200) {
      //     cache.put(url, null, 360000);
      //     throw new Error("Geo links error");
      // }
      const { title, tags } = resultJson?.data;
      let geoLinksData = null;
      if (title && tags.length) {
        geoLinksData = {
          title: title,
          links: formatGeoLinks(tags, url),
        };
      }
      return dispatch(GeoLinksSuccess(geoLinksData));
    } catch (error) {
      log.error("Error while fetching geo links API data", error);
      cache.put(url, null, 360000);
      return dispatch(GeoLinksFailure(error.message));
    }
  };
}

export function geoLinksReset() {
  return async (dispatch) => {
    dispatch(GeoLinksReset());
  };
}
